import React from 'react';
import { useIntl } from 'umi';
import PlusButton from '@/pages/datalab/components/PlusButton';
import type { INumericalValueRule } from '../../type';
import NumericalValuesRuleRow from './NumericalValuesRuleRow';

export interface INumericalValuesGroupRowsProps {
  groupId: string;
  rules: INumericalValueRule[];
  onAddRule: (groupId: string) => void;
  onDeleteRule: (groupId: string, ruleIndex: number) => void;
  onRuleChange: (
    groupId: string,
    ruleIndex: number,
    rule: INumericalValueRule,
  ) => void;
}

const NumericalValuesGroupRows: React.FC<INumericalValuesGroupRowsProps> = ({
  groupId,
  rules,
  onAddRule,
  onDeleteRule,
  onRuleChange,
}) => {
  const { formatMessage } = useIntl();
  const addConditionLabel = formatMessage({
    id: 'dbl_table_condition_add_condition',
  });

  return (
    <div className="dbl-numerical-values-grid__rows">
      {rules.map((rule: INumericalValueRule, ruleIndex: number) => (
        <NumericalValuesRuleRow
          key={`${groupId}-rule-${ruleIndex}`}
          rule={rule}
          onChange={nextRule => onRuleChange(groupId, ruleIndex, nextRule)}
          onDelete={() => onDeleteRule(groupId, ruleIndex)}
        />
      ))}

      <div className="dbl-numerical-values-grid__add-row">
        <PlusButton
          className="dbl-numerical-values-grid__add-condition"
          title={addConditionLabel}
          onClick={() => onAddRule(groupId)}
        />
      </div>
    </div>
  );
};

export default NumericalValuesGroupRows;
